import notificationClient from './client';
const opts = {
    headers: {
        Accept: '*/*',
        'Content-Type': 'application/vnd.newbay.msg-1.0+json',
    },
};
const apiType = 'nc';
export const notificationPost = async (body, endpoint, headers = {}, logger) => {
    logger ? notificationClient.setLogger(logger) : undefined;
    return notificationClient.post(endpoint, apiType, {
        data: body,
        ...opts,
        headers: { ...opts.headers, ...headers },
    });
};
